import React from "react";

// Botões de ação da tabela (editar/excluir/PDF) como ícone puro, sem fundo/borda, lado a lado no
// fim da linha — lápis e PDF em tinta neutra, lixeira em vermelho.
export function RowIconButton({
  icon,
  color,
  title,
  onClick,
  disabled,
}: {
  icon: string;
  color: string;
  title: string;
  onClick: () => void;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      title={title}
      aria-label={title}
      onClick={onClick}
      disabled={disabled}
      style={{
        background: "transparent",
        border: "none",
        padding: "6px 7px",
        borderRadius: "var(--radius-sm)",
        cursor: disabled ? "default" : "pointer",
        fontSize: "1.1rem",
        color,
        opacity: disabled ? 0.5 : 1,
        lineHeight: 1,
      }}
    >
      <i className={`bi bi-${icon}`} aria-hidden="true" />
    </button>
  );
}

export function EditIconButton(props: { title?: string; onClick: () => void; disabled?: boolean }) {
  return <RowIconButton icon="pencil" color="var(--sp-ink-2)" title={props.title ?? "Editar"} onClick={props.onClick} disabled={props.disabled} />;
}

export function DeleteIconButton(props: { title?: string; onClick: () => void; disabled?: boolean }) {
  return <RowIconButton icon="trash" color="var(--sp-danger)" title={props.title ?? "Excluir"} onClick={props.onClick} disabled={props.disabled} />;
}

// PDF (contrato/orçamento) é a ação mais procurada da linha: botão com texto, não só ícone.
export function PdfIconButton(props: { title?: string; onClick: () => void; disabled?: boolean }) {
  return (
    <button
      type="button"
      className="btn btn-secondary btn-sm d-inline-flex align-items-center gap-1"
      title={props.title ?? "Imprimir / baixar PDF"}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      <i className="bi bi-file-earmark-pdf" aria-hidden="true" />
      PDF
    </button>
  );
}
